import React from 'react';
import { useNavigate } from 'react-router-dom';

import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles';
import useIsPrivate from '../../hooks/useIsPrivate';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: 10,
  },
  container: {
    margin: '0 20px',
    padding: '20px 0',
    justifyContent: 'space-between',
    '& a': {
      color: '#fff',
      marginRight: '10px',
      textDecoration: 'none',
    },
  },
  link: {
    color: theme.palette.secondary.main,
    textDecoration: 'none',
  },
  button: {
    float: 'right',
    backgroundColor: '#739dc2 !important',
    color: 'white !important',
    '&:hover': {
      backgroundColor: '#407aac !important',
    },
  },
}));

const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const isPrivate = useIsPrivate();

  return (
    <Grid container className={classes.footer}>
      <Grid
        className={classes.container}
        container
        justifyContent={'space-between'}
        columnSpacing={4}
      >
        <Grid item xs={12} md={10}>
          <div>
            ASSONAVE - Associazione Nazionale dell’Industria Navalmeccanica,
            C.F. 80109350589, con sede legale in Via Tevere 1/A, 00198, Roma.
          </div>
          <div>
            <a
              href="https://www.assonave.it/policies/privacy"
              className={classes.link}
            >
              Privacy Policy
            </a>
            <a
              href="https://www.assonave.it/policies/cookie"
              className={classes.link}
            >
              {' '}
              Cookie Policy
            </a>
          </div>
        </Grid>
        {isPrivate && (
          <Grid item xs={12} md={2}>
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
              onClick={() => navigate('/associati/feedback')}
            >
              Feedback
            </Button>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default Footer;
